import { createContext } from 'react'

/** True inside BareLayout (auth screens, certificates): pages there have no top bar. */
export const BareContext = createContext(false)
